// start:ng42.barrel
export * from './user.model';
export * from './user-status-type.model';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/user/index.ts